import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ProfessionalRfpProposalListStatus } from '@/components/modules/pages/mypage/professional/List/ProfessionalRfpProposalList/ActionStatus';
import { ChangeHistoryOrangeIcon } from '@/components/ui/SvgIcon/Static/SvgIconComponents';
import { CircleNgIcon, CircleOutlineIcon, } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
export const ProfessionalRfpProposalListQuestionStatus = (props) => {
    const { isQuestion, questionDaysLeft, thresholdDays } = props;
    if (questionDaysLeft < 0 || !isQuestion) {
        return (_jsx(ProfessionalRfpProposalListStatus, Object.assign({ icon: CircleNgIcon, textColor: 'textGray' }, { children: "\u7DE0\u5207\u6E08" })));
    }
    if (questionDaysLeft <= thresholdDays) {
        return (_jsx(ProfessionalRfpProposalListStatus, Object.assign({ icon: ChangeHistoryOrangeIcon, iconColor: 'secondary' }, { children: "\u7DE0\u5207\u9593\u8FD1" })));
    }
    return (_jsx(ProfessionalRfpProposalListStatus, Object.assign({ icon: CircleOutlineIcon, iconColor: 'info' }, { children: "\u53D7\u4ED8\u4E2D" })));
};
